// Possible form builder schema
const form = {
  fields: [
    { // each root object represents a row in the form's layout
      firstName: {
        label: 'First Name',
        rules: [],
      },
      lastName: {
        label: 'Last Name',
        rules: [],
      },
    },
  ],
}

export default {
  required: [
    v => !!v || 'Field is required'
  ],
  nameRules: [
    v => (v.length > 1 || v.length == 0) || 'Field is too short',
    v => v.length < 128 || 'Field is too long',
    v => /^[a-zA-Z0-9 \-.]*$/.test(v) || 'Must not contain special characters'
  ],
  phoneRules: [
    v => (/^[2-9]\d{2}-\d{3}-\d{4}$/.test(v) || /^[2-9]\d{2}\d{3}\d{4}$/.test(v)) || 'Invalid phone number',
  ],
  zipRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v.length == 5 || v.length == 0) || 'Zip must be 5 numbers',
  ],
  routingNumberRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v.length == 9 || v.length == 0) || 'Routing number must be 9 numbers',
  ],
  accountNumberRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v.length >= 9 && v.length <= 12 || v.length == 0) || 'Account number must be 9–12 numbers',
  ],
  emailRules: [
    v => v.length <= 320 || 'Email is too long',
    v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
  ],
  ccRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => v.length >= 13 && v.length <= 19 || 'Invalid credit card number length',
  ],
  cvvRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => v.length <= 4 || 'Invalid CVV',
  ],
  yearRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => v.length == 4 || 'Year must be 4 digits',
  ],
  monthRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v <= 12 && v >= 1) || 'Month between 1 and 12',
  ],
  states: [
    'Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virgin Island','Virginia','Washington','West Virginia','Wisconsin','Wyoming'
  ],
  couponRules: [
    v => /^[a-z0-9_]*$/.test(v) || 'Coupon code must contain only numbers or lowercase letters.',
    // v => (v.length > 1 || v.length == 0) || 'Field is too short',
    // v => v == 'apafree6' || 'Not a valid coupon code'
  ],
  apaIdRules: [
    // v => (v.length > 1 || v.length == 0) || 'Field is too short',
    v => v.length < 10 || 'Field is too long',
    v => /^[a-zA-Z0-9_]*$/.test(v) || 'Must contain only numbers or letters'
    // Required if couponRules == true, apaId is required.
    // Does apaId match apaIds list?
  ],
}
